import React from 'react';
import {Map, List} from 'immutable';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Atom, Plugins, withMeta, withSystem} from '@packages/systems/wfdl';
import {commerceCountryList} from '@packages/systems/core/constants/SharedConfig';
import {checkoutInputStyle, mobileCheckoutInputStyle} from './styles';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {TEnum} from '@packages/systems/wfdl-ast';
import {getInPojo, getStringOrElse} from '@packages/utilities/data-utils';

const sortedCountries = commerceCountryList
  .sort((a, b) => a.name.localeCompare(b.name))
  .map(({code, name}) => (
    <option value={code} key={code}>
      {name}
    </option>
  ));

const CountrySelector = Atom.createRender(
  ({attributes, classes, generateAttributes, data}) => {
    return (
      // eslint-disable-next-line jsx-a11y/no-onchange
      <select
        {...generateAttributes(attributes, classes)}
        name="address_country"
        value={getStringOrElse(getInPojo(data, ['defaultCountry']), 'US')}
        onChange={() => {
          // this onChange is here to make React's linter happy
        }}
      >
        {sortedCountries}
      </select>
    );
  }
);

const staticBindings = Map({
  value: List([
    Map({
      slug: 'billingAddressCountry',
      type: 'PlainText',
    }),
  ]),
});

const config = createIntegratedAtom({
  displayName: 'Country',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Select')),
  },
  showEmpty: false,
  render: CountrySelector,
  style: {
    base: {
      main: {
        ...checkoutInputStyle,
        noPseudo: {
          ...checkoutInputStyle.noPseudo,
          marginBottom: px(0),
        },
      },
      tiny: mobileCheckoutInputStyle,
    },
  },
  staticBindings,
  fields: {
    defaultCountry: withSystem(
      {
        label: 'Default billing address country',
        isFullWidth: true,
        defaultValue: 'US',
      },
      withMeta(
        {variant: 'menu', withoutLivePreview: true},
        TEnum(
          commerceCountryList.reduce<Record<string, string>>(
            (acc, {code, name}) => {
              acc[code] = name;
              return acc;
            },
            {}
          )
        )
      )
    ),
  },
});

export default config;
